import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Provider from "./context";
import '@radix-ui/themes/styles.css';
import { Theme } from "@radix-ui/themes";
import { Toaster } from "react-hot-toast";
import SocketContext from "socket-context";
import { UserInfoMapperSocketHandler } from "utils/UserInfoMapper";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

export type socketContextType = {
  roomId: string | number;
  socketObject: UserInfoMapperSocketHandler;
  userIdU: any;
}

const socketList: socketContextType[] = [];
root.render(
  <React.StrictMode>
    <Provider>
      <SocketContext.Provider value={socketList}>
      <Theme accentColor="plum" radius="full">
        <Toaster position="top-center" />
        <App />
      </Theme>
      </SocketContext.Provider>
    </Provider>
  </React.StrictMode>
);
